import { ComponentPropsWithoutRef, ReactNode, forwardRef } from "react"

import { Icon, IconExternalLink } from "@tabler/icons-react"

import { cn } from "@/lib/utils"

export interface TextLinkProps extends ComponentPropsWithoutRef<"a"> {
  icon?: Icon
  iconPosition?: "left" | "right"
  hideUnderline?: boolean
  dark?: boolean
  disabled?: boolean
  children: ReactNode
  component?: "a" | "span"
}

export const TextLink = forwardRef<HTMLAnchorElement, TextLinkProps>(function TextLink(
  {
    icon,
    iconPosition,
    hideUnderline = false,
    dark = false,
    disabled,
    className,
    children,
    href,
    component = "a",
    ...props
  },
  ref,
) {
  const Icon = icon || IconExternalLink
  const Comp = component

  return (
    <Comp
      ref={ref}
      aria-disabled={disabled}
      href={disabled ? undefined : href}
      rel="noreferrer"
      className={cn(
        "inline w-fit cursor-pointer items-center aria-disabled:cursor-default [&>svg]:inline",
        dark
          ? "text-brand-primary-100 visited:text-brand-secondary-300 hover:text-white aria-disabled:text-grey-400"
          : "text-colors-text-link visited:text-brand-secondary-500 hover:text-brand-primary-900 aria-disabled:text-grey-400",
        !hideUnderline ? "underline underline-offset-2" : "",
        className,
      )}
      {...props}
    >
      {iconPosition === "left" && (
        <Icon size="1em" className="relative bottom-[.125em] mr-1" />
      )}
      {children}
      {iconPosition === "right" && (
        <Icon size="1em" className="relative bottom-[.125em] ml-1" />
      )}
    </Comp>
  )
})
